import { Outlet } from "react-router-dom";
import { UserComponent } from "../../components/user/UserComponent";
import elypseImg from "../../assets/img/MIA_circulo-azul.png";
import { TabLayout } from "../../components/Tabs/TabLayout";
import { useMediaQuery } from "@react-hook/media-query";
import styles from "./Layout.module.css";
import { useLayout } from "../../contexts/useLayoutContext";
import { useUser } from "../../contexts/useUserData";
import { scopes_B2B, scopes_B2B_Migedi, scopes_B2C, scopes_B2C_Telco, scopes_O2, scopes_eSimFlag} from "../../infraestructure/models";
import { useState, useEffect } from "react";
import { useChat } from "../../contexts/useChatData";
import { originLink } from "../../components/Answer/AnswerLinks"; // Importa la función originLink
import QuestionMarkCircle from "../../assets/svgComponents/QuestionMarkCircle";

const Layout = () => {
    const { menuOpen, toogleMenuOpen } = useLayout();
    const { seccion, pushScope, scope, user, userDepartment } = useUser(); // Paso 2: Consume el valor de seccion aquí
    const userFinal = user && user.length > 12 ? "Usuario Telco" : user;

    // // Clases para logo de Elypse
    // let logoElypseClassName = styles.logoElypse; // Clase por defecto
    // if (scope === "Empresas ME" || scope === "Empresas GGCC") {
    //     logoElypseClassName += ` ${styles.logoElypseMEGC}`;
    // } else if (scope === "Empresas PE") {
    //     logoElypseClassName += ` ${styles.logoElypsePE}`;
    // }

    // // Clases para el desplegable de los scopes
    // let dropdownClassName = styles.dropdown; // Clase por defecto
    // if (scope === "Empresas ME" || scope === "Empresas GGCC") {
    //     dropdownClassName += ` ${styles.dropdownMEGC}`;
    // } else if (scope === "Empresas PE") {
    //     dropdownClassName += ` ${styles.dropdownPE}`;
    // }

    // let mensajeBienvenida = styles.user;
    // if (scope === "Empresas ME" || scope === "Empresas GGCC") {
    //     mensajeBienvenida += ` ${styles.mensajeBienvenidaMEGC}`;
    // } else if (scope === "Empresas PE") {
    //     mensajeBienvenida += ` ${styles.mensajeBienvenidaPE}`;
    // }

    let dropdownClassName = styles.dropdown; // Clase por defecto

    // Añade clases condicionales según el scope
    if (scope === "Empresas ME" || scope === "Empresas GGCC") {
        dropdownClassName += ` ${styles.dropdownMEGC}`;
    } else if (scope === "Empresas PE") {
        dropdownClassName += ` ${styles.dropdownPE}`;
    }

    const isResponsive = useMediaQuery("(max-width: 768px)");
    const [scopes, setScopes] = useState<string>();
    // let url_user = "";
    const { cleanAnswers, isLoading, linkToken } = useChat();
    const [openChat, setOpenChat] = useState(false);

    useEffect(() => {
        if (openChat) {
            setOpenChat(false);
        }
    }, [openChat]);

    useEffect(() => {
        const newChatElement = document.getElementById("new-chat");

        if (newChatElement) {
            if (isLoading) {
                newChatElement.setAttribute("disabled", "true");
                newChatElement.classList.add("disabled-opacity");
            } else {
                newChatElement.removeAttribute("disabled");
                newChatElement.classList.remove("disabled-opacity");
            }
        }
    }, [isLoading]);

    function handleClick() {
        cleanAnswers!(true);
        setOpenChat(false);
    }

    const toggleMenu = () => {
        toogleMenuOpen!();
        if (!menuOpen) {
            document.body.classList.add("open-nav");
        } else {
            document.body.classList.remove("open-nav");
        }
    };
    
    // const userFinal = user && user.length > 12 ? "Usuario Telco" : user;

    function handleDropdownChange(event: React.ChangeEvent<HTMLSelectElement>) {
        setScopes(event.target.value);
    }

    const selectScopes = (dataScopes: string[]) => {
        return (
            <select
                className={dropdownClassName}
                onChange={event => {
                    handleDropdownChange(event);
                    handleClick();
                    pushScope!(event.target.value);
                    console.log(event.target.value);
                }}
            >
                {dataScopes.map((element, index) => (
                    <option selected={element === scope} key={index} value={element}>
                        {element}
                    </option>
                ))}
            </select>
        );
    };

    //const userFinal = user && user.length > 12 ? "Usuario Telco" : user;

    return (
        <div className={styles.layout}>
            <div className={styles.wrapperSearchbot}>
                <nav className={styles.wrapperSearchbotNav}>
                    {/* <div className={styles.logoElypse}></div> */}
                    <div className={styles.closeIconHolder}>
                        {isResponsive && menuOpen === true && (
                            <div className={styles.closeMenu} onClick={toggleMenu}>
                                <span></span>
                                <span></span>
                            </div>
                        )}
                    </div>
                    <div className={styles.dropdown}>
                        {seccion === "B2B" && ((userDepartment === "MIGEDI" || userDepartment === "Contributors") ? selectScopes(scopes_B2B_Migedi) : selectScopes(scopes_B2B))}
                        {/* {seccion === "B2C" && (userFinal === "Usuario Telco" ? selectScopes(scopes_B2C_Telco) : selectScopes(scopes_B2C))} */}
                        {seccion === "O2" && selectScopes(scopes_O2)}
                        {seccion === "eSimFlag" && selectScopes(scopes_eSimFlag)}
                        {/* {url_user.toUpperCase() === B2X && (
                            <select
                            className={styles.dropdown}
                            onChange={(event) => {
                                const selectedValue = event.target.value;
                                handleDropdownChange(event);
                                handleClick();
                                setScope(selectedValue); // Actualiza el estado de seccion
                                pushSeccion!(selectedValue); // Actualiza la sección
                            }}
                            value={seccion}
                        >
                                {seccions_B2CB2B.map((element, index) => (
                                    <option key={index} value={element}>
                                        {element}
                                    </option>
                                ))}
                            </select>
                        )} */}
                    </div>

                    <br />
                    {/* {isResponsive && menuOpen === true && (
                        <div className={styles.closeMenu} onClick={toggleMenu}>
                            <span></span>
                            <span></span>
                        </div>
                    )} */}
                    <div className={styles.tabLayoutContainer}>
                        <TabLayout menuOpen={toggleMenu} />
                    </div>
                    <div className={styles.userComponentContainer}>
                        <UserComponent />
                    </div>
                </nav>
                <main className={styles.wrapperSearchbotMain}>
                    <header className={styles.header} role={"banner"}>
                        <div className={styles.headerContainer}>
                            {isResponsive && menuOpen === false && (
                                <div className={styles.hamburguer} onClick={toggleMenu}>
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </div>
                            )}

                            {/* <div className={styles.headerImage}></div> */}
                        </div>
                        {/* Imagen con hipervínculo a la guía de IArte */}
                        {seccion === "B2C" && (
                            <div className={styles.imageLinkContainer}>
                                <a
                                    href={`${originLink(linkToken!, seccion!)}${"/render/genericRender.xhtml?id=5080427&type=0&source=chat"}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <QuestionMarkCircle className={styles.imageLink} />
                                </a>
                            </div>
                        )}
                    </header>
                    <div className={styles.wrapperMessages}>
                        <div className={styles.user}>
                            <div className={styles.userWraperInitial}>
                                <img src={elypseImg} alt="logo-elypse" />
                                <p>Bienvenido al chat, soy MIA</p>
                            </div>
                        </div>

                        <Outlet />
                    </div>
                </main>
            </div>
        </div>
    );
};

export default Layout;
